var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ion-app',[_c('ion-vue-router')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }